<template>
    <div class="loader">
        <div class="loader-circle"></div>
    </div>
</template>

<script>
    export default {
        name: "Loader"
    }
</script>

<style lang="scss" scoped>
    @import "../scss/variables";

    .loader {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        .loader-circle {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: solid 2px transparent;
            border-bottom-color: var(--text-color);
            animation: loader infinite 1s;
        }

        &.color {
            .loader-circle {
                border-bottom-color: var(--accent-color);
            }
        }
    }

    @keyframes loader {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
